import React from 'react'

import { func } from 'prop-types'

function Resend({ onResend, onChangeEmail }) {
  return (
    <p className="auth-modal__resend cgt-body-base">
      Didn&apos;t receive it?
      {' '}
      <button
        type="button"
        className="auth-modal__switch-link auth-modal__resend-link cgt-link-primary-accented"
        onClick={onResend}
      >
        Resend code
      </button>
      <span className="auth-modal__resend-separator" aria-hidden="true">&middot;</span>
      <button
        type="button"
        className="auth-modal__switch-link auth-modal__change-email-link cgt-link-primary-accented"
        onClick={onChangeEmail}
      >
        Change email
      </button>
    </p>
  )
}

Resend.propTypes = {
  onResend: func.isRequired,
  onChangeEmail: func.isRequired,
}

export default Resend
